import { Injectable } from "@angular/core";

import { StateSearchCriteria } from "@models/StateSearchCriteria";

import { PlantsService } from "./plants.service";

@Injectable()
export class StateSearchResolver {
  constructor(private ps: PlantsService) {}

  async resolve(): Promise<StateSearchCriteria> {
    const criteria = await this.ps.getStateSearchCriteria();
    return criteria;
  }
}
